import { supabase } from '../supabaseClient'
import { removeItem } from '../utils/localStorage'
class AuthService {
  getUserProfile = async (): Promise<any> => {
    try {
      const user = (await supabase.auth.getSession()).data.session?.user

      if (!user) throw new Error('No user on the session!')

      const {
        data: profileData,
        error: profileError,
        status: profileStatus,
      } = await supabase.from('profiles').select('*').eq('uuid', user.id).single()

      if (profileError && profileStatus !== 406) {
        return null
      }

      const { data: agentData, error: agentError } = await supabase
        .from('agents')
        .select('role, status, supplier_uuid')
        .eq('uuid', user.id)
        .single()

      if (agentError) {
        console.error('Error retrieving role from agents table:', agentError)
      }

      return {
        ...profileData,
        role: agentData?.role || null,
        agentStatus: agentData?.status,
        ...(agentData?.role === 'SUPPLIER' && {
          supplier_uuid: agentData.supplier_uuid,
        }),
      }
    } catch (error) {
      console.error({ error })
    }
  }

  verifyUser = async (email: string): Promise<{ success: boolean; error?: string }> => {
    try {
      const { data: profileData, error: profileError } = await supabase
        .from('simple_profile')
        .select('uuid')
        .eq('email', email)
        .single()

      if (profileError || !profileData) {
        return { success: false, error: 'Profile not found or error fetching profile.' }
      }

      const { uuid } = profileData

      const { data: agentData, error: agentError } = await supabase
        .from('agents')
        .select('role, status')
        .eq('uuid', uuid)
        .single()

      if (agentError || !agentData) {
        return { success: false, error: 'Agent record not found or error fetching agent data.' }
      }

      const { role, status: agentStatus } = agentData

      const allowedRoles = ['AGENT', 'ADMIN', 'SUPERADMIN', 'SUPPLIER']
      if (!allowedRoles.includes(role)) {
        return { success: false, error: 'Access denied: Invalid role.' }
      }

      if (agentStatus !== 'ACTIVE') {
        return { success: false, error: 'Access denied: Inactive account.' }
      }

      return { success: true }
    } catch (error) {
      console.error('Error during user verification:', error)
      return { success: false, error: 'An unexpected error occurred during verification.' }
    }
  }

  onSignOut = async () => {
    try {
      await supabase.auth.signOut()
      removeItem('token')
    } catch (error) {
      console.error({ error })
    }
  }
}

const authService = new AuthService()

export default authService
